"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n\n    &:hover {\n        box-shadow: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return props.interactive ? props.theme.hoverBoxShadow : props.theme.boxShadow;
});

var _default = Root;
exports["default"] = _default;